// Renders the price finder, tables, packages, FAQ, and reviews for the
// Grooming With Kate landing page. Reads data from window.GWK (gwk-pricing.js).
// Scoped to elements inside .gwk-landing so it never touches theme markup.
document.addEventListener('DOMContentLoaded', function () {
  const GWK = window.GWK;
  if (!GWK) return;

  const fmt = (n) => `$${n}`;

  // Wire every "Become a Client" CTA to the MoeGo application form.
  document.querySelectorAll('[data-gwk-apply]').forEach((a) => {
    a.href = GWK.APPLICATION_URL;
    a.target = '_blank';
    a.rel = 'noopener';
  });

  // ---- Price finder ----
  const coatSelect = document.getElementById('gwk-coat-select');
  const weightSelect = document.getElementById('gwk-weight-select');
  const examplesEl = document.getElementById('gwk-coat-examples');
  const resultsEl = document.getElementById('gwk-finder-results');

  if (coatSelect && weightSelect && resultsEl) {
    Object.entries(GWK.PRICING).forEach(([key, cfg]) => {
      const opt = document.createElement('option');
      opt.value = key;
      opt.textContent = cfg.label;
      coatSelect.appendChild(opt);
    });

    const renderWeights = () => {
      const cfg = GWK.PRICING[coatSelect.value];
      weightSelect.innerHTML = '';
      cfg.weights.forEach((w, i) => {
        const opt = document.createElement('option');
        opt.value = i;
        opt.textContent = w;
        weightSelect.appendChild(opt);
      });
      if (examplesEl) examplesEl.textContent = cfg.examples ? `e.g. ${cfg.examples}` : '';
    };

    const renderPrices = () => {
      const cfg = GWK.PRICING[coatSelect.value];
      const row = cfg.rows[Number(weightSelect.value)];
      resultsEl.innerHTML = GWK.PACKAGES.map((pkg, i) => `
        <div class="price-tile${i === 1 ? ' featured' : ''}">
          <div class="pkg">${pkg.name}${i === 1 ? ' · Most popular' : ''}</div>
          <div class="amount">${fmt(row[i])}</div>
          <div class="hint">${pkg.tagline}</div>
        </div>
      `).join('');
    };

    coatSelect.addEventListener('change', () => { renderWeights(); renderPrices(); });
    weightSelect.addEventListener('change', renderPrices);
    renderWeights();
    renderPrices();
  }

  // ---- Full pricing tables ----
  const allTablesEl = document.getElementById('gwk-all-tables');
  if (allTablesEl) {
    allTablesEl.innerHTML = Object.values(GWK.PRICING).map((cfg) => `
      <h4>${cfg.label}</h4>
      ${cfg.examples ? `<p class="examples">${cfg.examples}</p>` : ''}
      <div class="table-scroll"><table class="price-table">
        <thead><tr><th>Weight</th><th>Standard</th><th>Premium</th><th>Platinum</th></tr></thead>
        <tbody>
          ${cfg.weights.map((w, i) => `
            <tr><td>${w}</td>${cfg.rows[i].map((p) => `<td>${fmt(p)}</td>`).join('')}</tr>
          `).join('')}
        </tbody>
      </table></div>
    `).join('');
  }

  // ---- A la carte ----
  const nailsNoteEl = document.getElementById('gwk-nails-note');
  const alacarteListEl = document.getElementById('gwk-alacarte-list');
  if (nailsNoteEl) nailsNoteEl.textContent = GWK.NAILS_ONLY_NOTE;
  if (alacarteListEl) {
    alacarteListEl.innerHTML = GWK.ALA_CARTE.map(
      ([name, price]) => `<li>${name}<span class="price">${fmt(price)}</span></li>`,
    ).join('');
  }

  // ---- Packages ----
  const packageGridEl = document.getElementById('gwk-package-grid');
  if (packageGridEl) {
    packageGridEl.innerHTML = GWK.PACKAGES.map((pkg) => `
      <div class="package-card">
        <h3>${pkg.name}</h3>
        <p class="tagline">${pkg.tagline}</p>
        <ul>${pkg.includes.map((item) => `<li>${item}</li>`).join('')}</ul>
      </div>
    `).join('');
  }

  // ---- FAQ ----
  const faqListEl = document.getElementById('gwk-faq-list');
  if (faqListEl) {
    faqListEl.innerHTML = GWK.FAQS.map(([q, a]) => `
      <details class="faq-item">
        <summary>${q}</summary>
        <p>${a}</p>
      </details>
    `).join('');
  }

  // ---- Reviews ----
  const reviewGridEl = document.getElementById('gwk-review-grid');
  if (reviewGridEl) {
    reviewGridEl.innerHTML = GWK.REVIEWS.map(([quote, name]) => `
      <figure class="review-card">
        <div class="stars" aria-label="5 out of 5 stars">★★★★★</div>
        <blockquote>${quote}</blockquote>
        <figcaption>${name}</figcaption>
      </figure>
    `).join('');
  }

  // ---- Service area town list ----
  const townListEl = document.getElementById('gwk-town-list');
  if (townListEl) {
    townListEl.innerHTML = GWK.TOWNS.map((t) => `<li>${t}</li>`).join('');
  }
});
